import { render, staticRenderFns } from "./Info2.vue?vue&type=template&id=2c5164fa&scoped=true&"
import script from "./Info2.vue?vue&type=script&lang=js&"
export * from "./Info2.vue?vue&type=script&lang=js&"
import style0 from "./Info2.vue?vue&type=style&index=0&id=2c5164fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5164fa",
  null
  
)

/* custom blocks */
import block0 from "./Info2.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports